import api from './api';

/**
 * API dei modelli di consenso informato.
 */
export const templateAPI = {
    // Elenco modelli (filtrato lato server in base al ruolo)
    getAll: (params) => api.get('/template', { params }),

    // Singolo modello, con le prestazioni associate
    getById: (id) => api.get(`/template/${id}`),

    create: (data) => api.post('/template', data),
    update: (id, data) => api.put(`/template/${id}`, data),
    disattiva: (id) => api.delete(`/template/${id}`),

    // Modelli richiesti da una prestazione
    getPerPrestazione: (prestazioneId) => api.get(`/template/prestazione/${prestazioneId}`),

    // Associazione modello <-> prestazione
    associa: (templateId, prestazioneId, obbligatorio = true) =>
        api.post(`/template/${templateId}/prestazioni`, { prestazione_id: prestazioneId, obbligatorio }),
    dissocia: (templateId, prestazioneId) =>
        api.delete(`/template/${templateId}/prestazioni/${prestazioneId}`),

    // Firma del consenso in sede di prestazione
    firma: (data) => api.post('/template/firma', data),
};

export default templateAPI;
